<script>
    import Alert from './componentes/Alert.svelte';    
	import ButtonViewsXpages from './componentes/ButtonViewsXpages.svelte';
	import Helper from './components/Helper.svelte';
	import BotonOrder from './componentes/BotonOrder.svelte'; // CAMBIO AGREGAR 
	import { viewsXpages, registerXpage, urlapp, iduser } from './stores/store.js'; // CAMBIO AGREGAR quitar duplicado
	import ColorStatus from './componentes/ColorStatus.svelte';
    import Input from './componentes/Forms/Input.svelte';
    import Modal from './components/Modal.svelte';
    import { fade, fly } from 'svelte/transition';  import { push } from 'svelte-spa-router';
    import AnimationContainer from './components/AnimationContainer.svelte';
    import Navbar from './components/Navbar.svelte';
    import Titlesection from "./components/Titlesection.svelte";
    import { autentificado, prefix, urlapi, login,miPermiso,sucursal,sucursalStore } from './stores/store';

    import DatagridRow from './componentes/DatagridRow.svelte';
    import DatagridTitle from './componentes/DatagridTitle.svelte';
    import DatagridCell from './componentes/DatagridCell.svelte';
    import Datagrid from './componentes/Datagrid.svelte';

    import Infopagination from './components/Infopagination.svelte';
    import Pagination from './components/Pagination.svelte';
    import Searchsection from "./components/Searchsection.svelte";
    import { moneda, object2array, postData, verifyAccess } from './scripts';

    import moment from 'moment';

    //verifyAccess($login,$miPermiso,'facturacion','access')

    /* PERMISOS */
    let viewPage=false;

    if($login===false)
    {
        push('/login')
    } else if( $miPermiso.facturacion.access===false ) {
        push('/sinpermiso')
    } else {
        viewPage=true;
    }
    /* FIN PERMISOS */

    let helper=false;

    let errores_anulacion=false;
    let errores_anulacion_mensajes=[];

    const res=null;
    let datagrid=[]
    let cargando=false;
    let pageActual=0;
    let dataPagination={};
    let searchText='';
    let orderField='numdoc';
    let orderDir='DESC';
    let disabled_count=true;
    let avanzado=false;
    let searchSucursal='0';
    let destino='0';
    let tipo='0';

    let desde='00-00-0000';
    let hasta='00-00-0000';

    let filtrohoy=false;

    if( $miPermiso.facturacion.filtrodia===true )
    {
        filtrohoy=true;
    }

    let uid=null; // CAMBIO AGREGAR VARIABLE

    let seleccionado=false;
    let seleccionadostatus=false;

    let offcanvas_cortedia=false;
    let Bsoffcanvas_cortedia=false;
    let fecha_cortedia='';
    let observaciones_cortedia='';
    let campo_cortedia=null;

    let offcanvas_cortediaUNI=false;
    let Bsoffcanvas_cortediaUNI=false;
    let fecha_cortediaUNI='';
    let observaciones_cortediaUNI='';
    let campo_cortediaUNI=null;
    
    let sucursales=[{0:'Sin filtrar'}];
    Object.keys($sucursalStore).map(function(value) { sucursales=[...sucursales,{[value] :$sucursalStore[value]}] });  

    let nuevo=function () { push('/ventas')}

    function openCortedia()
    {
        fecha_cortedia=moment().format('YYYY-MM-DD');
        observaciones_cortedia='';
        usuarioCombo=usuarioInicial;
        
        Bsoffcanvas_cortedia = new bootstrap.Offcanvas(offcanvas_cortedia)
        Bsoffcanvas_cortedia.show()
        campo_cortedia.onlyFocusInNum(400)
    }

    function openCortediaUnidades()
    {
        fecha_cortediaUNI=moment().format('YYYY-MM-DD');
        observaciones_cortediaUNI='';
        usuarioCombo=usuarioInicial;
        
        Bsoffcanvas_cortediaUNI = new bootstrap.Offcanvas(offcanvas_cortediaUNI)
        Bsoffcanvas_cortediaUNI.show()
        campo_cortediaUNI.onlyFocusInNum(400)
    }

    function closeCortedia()
    {
        Bsoffcanvas_cortedia.hide()
    }
    
    function closeCortediaUNI()
    {
        Bsoffcanvas_cortediaUNI.hide()
    }

    function verFactura()
    {
        let get_corte='';
        get_corte+=`?id=`+seleccionado; 
        window.open($urlapp+'print/factura.php'+get_corte);
    }

    function cortedia()
    {
        let get_corte='';

        if($miPermiso.facturacion.cortediaselectuser===true)
        {
            get_corte+=`?id=`+usuarioCombo;
        } else {
            get_corte+=`?id=`+$iduser;
        }
        
        let dateurl = moment(fecha_cortedia)
        if(dateurl.isValid()) { get_corte+=`&fecha=`+encodeURIComponent(moment(fecha_cortedia,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD")); }
        if(observaciones_cortedia.trim()!='') {get_corte+=`&observaciones=`+encodeURIComponent(observaciones_cortedia)}
        window.open($urlapp+'print/corte_dia.php'+get_corte);
        closeCortedia();
    }

    function cortediaUNI()
    {
        let get_corte='';

        if($miPermiso.facturacion.cortediaselectuser===true)
        {
            get_corte+=`?id=`+usuarioCombo;
        } else {
            get_corte+=`?id=`+$iduser;
        }

        let dateurl = moment(fecha_cortediaUNI)
        if(dateurl.isValid()) { get_corte+=`&fecha=`+encodeURIComponent(moment(fecha_cortediaUNI,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD")); }
        if(observaciones_cortediaUNI.trim()!='') {get_corte+=`&observaciones=`+encodeURIComponent(observaciones_cortediaUNI)}
        window.open($urlapp+'print/corte_dia_unidades.php'+get_corte);
        closeCortediaUNI();
    }    


    let selected= function (event) { 
        if(seleccionado==false || seleccionado!==event.detail.id) {
            seleccionado=event.detail.id
            let obj = datagrid.find(o => o.numdoc === seleccionado);
            if(obj.estado=='E') { seleccionadostatus=true; } else { seleccionadostatus=false; }
        } else {
            seleccionado=false
        }
    }

    function eventPage(event)
    {
        pageActual=event.detail.text;
        loadData()
    }

    function eventSearch(event)
    {
        pageActual=0;
        searchText=event.detail.text
        loadData()
    }
    
    // CAMBIO AGREGAR FUNCION
    function eventText()
    {
        pageActual=0;
        loadData()
    }

    function orderTable(event) {
        if(cargando===false) {
            pageActual=0;
            orderField=event.detail.order;
            orderDir=event.detail.dir;
            loadData()
        }
    }
    
    let usuario=null;
    let usuarioCombo=null;
    let usuarioInicial=null;
    let usuarioFilter=false;

    let usuarios=[{'0':'Sin Filtrar'}];
    let usuariosCombo=[];
    postData($urlapi, [{'cmd': "users_comboList",sucursal: $sucursal}])
    .then(data => {
        if(Object.getOwnPropertyNames(data[0].result).length>0) {
            for (const property in data[0].result) {
                usuarios=[...usuarios,{[property]:data[0].result[property]}]
                usuariosCombo=[...usuariosCombo,{[property]:data[0].result[property]}]
                if(usuarioCombo===null) usuarioCombo=property
            }
            usuarioInicial=usuarioCombo;
        }
    });

    if($miPermiso.facturacion.viewSelf===true) {
        usuario=$iduser
        usuarioFilter=true;
    } else {
        usuario='0'
        usuarioFilter=false;
    }

    async function loadData()
    {
        let datos={ 
          'cmd': "facturas_list",
          sucursal: $sucursal,
          pagination: $viewsXpages,
          page: pageActual,
          order: orderField,
          dir: orderDir 
        }

        // CAMBIO AGREGAR CONDICION Y BORRAR SEARCH DE ARRIBA
        if(avanzado===true)
        {
            if(searchText!='') datos={...datos, 'search':searchText }
            if(tipo!=='0') datos={...datos, 'tipo':tipo }
            if(usuario!=='0') datos={...datos, 'usuario':usuario }
            if(desde!=='00-00-0000' && desde!=='') datos={...datos, 'desde':desde }
            if(hasta!=='00-00-0000' && hasta!=='') datos={...datos, 'hasta':hasta }
        } else if(usuarioFilter===true) {
            if(usuario!=='0') datos={...datos, 'usuario':usuario }
        }
        if(filtrohoy===true) datos={...datos, 'filtrohoy':filtrohoy }
        

        cargando=true;
        const res = await postData($urlapi, [datos])
        .then(data => {
            datagrid= object2array(data[0].result);

            dataPagination=data[0].pagination;
            cargando=false;
            if(Number(dataPagination.resultados)>0)
            {
                disabled_count=false;
            } else {
                disabled_count=true;
            }
        });          
    }
    
    function acumulado_ventas_dia()
    {
        let get_corte='';
        
        get_corte+=`?sucursal=`+$sucursal;
        
        let desdeurl = moment(desde)
        let hastaurl = moment(hasta)
        if(desdeurl.isValid()) { get_corte+=`&desde=`+encodeURIComponent(moment(desde,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD")); } else { get_corte+=`&desde=0000-00-00`; }
        if(hastaurl.isValid()) { get_corte+=`&hasta=`+encodeURIComponent(moment(hasta,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD")); } else { get_corte+=`&hasta=0000-00-00`; }
        
        window.open($urlapp+'print/acumulado_venta_dias.php'+get_corte);
    }

    function corte_periodo()
    {
        let get_corte='';
        if(searchText === undefined)
        {
            get_corte+=`?search=`;
        } else {
            get_corte+=`?search=`+encodeURIComponent(searchText);
        }
        
        get_corte+=`&tipo=`+encodeURIComponent(tipo);
        get_corte+=`&usuario=`+encodeURIComponent(usuario);
        get_corte+=`&sucursal=`+encodeURIComponent($sucursal);
        
        let desdeurl = moment(desde)
        let hastaurl = moment(hasta)
        if(desdeurl.isValid()) { get_corte+=`&desde=`+encodeURIComponent(moment(desde,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD")); } else { get_corte+=`&desde=0000-00-00`; }
        if(hastaurl.isValid()) { get_corte+=`&hasta=`+encodeURIComponent(moment(hasta,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD")); } else { get_corte+=`&hasta=0000-00-00`; }
        
        window.open($urlapp+'print/facturas_periodo.php'+get_corte);
    }

    function corte_periodo_excel()
    {
        let get_corte='';
        if(searchText === undefined)
        {
            get_corte+=`?search=`;
        } else {
            get_corte+=`?search=`+encodeURIComponent(searchText);
        }
        
        get_corte+=`&tipo=`+encodeURIComponent(tipo);
        get_corte+=`&usuario=`+encodeURIComponent(usuario);
        get_corte+=`&sucursal=`+encodeURIComponent($sucursal);
        
        let desdeurl = moment(desde,["DD-MM-YYYY","YYYY-MM-DD"])
        let hastaurl = moment(hasta,["DD-MM-YYYY","YYYY-MM-DD"])
        if(desdeurl.isValid()) { get_corte+=`&desde=`+encodeURIComponent(moment(desde,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD")); } else { get_corte+=`&desde=0000-00-00`; }
        if(hastaurl.isValid()) { get_corte+=`&hasta=`+encodeURIComponent(moment(hasta,["DD-MM-YYYY","YYYY-MM-DD"]).format("YYYY-MM-DD")); } else { get_corte+=`&hasta=0000-00-00`; }

        window.open($urlapp+'excel/facturas_periodo.php'+get_corte);
    }    

    function anular()
    {
        errores_anulacion_mensajes=[];
        const res = postData($urlapi, [{'cmd': "facturas_anular", id: seleccionado}])
        .then(data => {
            if(data[0].error===true)
            {
                errores_anulacion_mensajes=object2array(data[0].errores);
                errores_anulacion=true;
            } else {
                errores_anulacion=false;
                loadData();
                seleccionado=false;                
            }

            //console.log(data[0])

        });  
    }

</script>

{#if viewPage===true}
<Navbar />
<AnimationContainer>
    <Titlesection>
        <span slot="title"><i class="bi bi-cart4 me-1" />Facturas</span>
        <span slot="toolbar">
            
            {#if $miPermiso.facturacion.insert===true}
                <button class='btn btn-primary' on:click={nuevo} on:mouseenter={()=>helper='Crear Factura'} on:mouseleave={()=>helper=false}><i class="bi bi-plus-circle"></i></button>
            {/if}

            {#if $miPermiso.facturacion.annul===true}
                <span on:mouseenter={()=>helper='Anular Factura'} on:mouseleave={()=>helper=false}>
                <Modal classButton='btn-danger' iconButton='bi-file-earmark-x' functionSi={anular} title='ADVERTENCIA' disabled={!seleccionado || !seleccionadostatus}>
                    Esta seguro que desea <strong>Anular</strong> la factura?
                </Modal>
                </span>
            {/if}

            {#if avanzado===false}
                <button class='btn btn-secondary' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='Buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
            {:else}
                <button class='btn btn-success' on:click={(e)=>{avanzado=!avanzado; eventSearch(e);}} on:mouseenter={()=>helper='Buscador avanzado'} on:mouseleave={()=>helper=false}><i class="bi bi-funnel"></i></button>
            {/if}

            <span on:mouseenter={()=>helper='Filtrar facturas de hoy'} on:mouseleave={()=>helper=false}>
            {#if filtrohoy===false}
                <button class='btn btn-secondary' on:click={(e)=>{filtrohoy=!filtrohoy; eventSearch(e);}} ><i class="bi bi-calendar-check-fill"></i></button>
            {:else}
                <button class='btn btn-success' on:click={(e)=>{filtrohoy=!filtrohoy; eventSearch(e);}}><i class="bi bi-calendar-check-fill"></i></button>
            {/if}
            </span>


            {#if $miPermiso.facturacion.view===true}
                <span on:mouseenter={()=>helper='Ver Factura'} on:mouseleave={()=>helper=false}>
                    <button disabled={!seleccionado} class='btn btn-info' on:click={verFactura}><i class="bi bi-search text-white"></i></button>
                </span>
            {/if}

            {#if $miPermiso.facturacion.cortedia===true}
                <span on:mouseenter={()=>helper='Corte del día'} on:mouseleave={()=>helper=false}>
                    <button disabled={disabled_count} type="button" class="btn btn-success text-white dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-printer text-white me-1"></i><i class="bi bi-scissors text-white"></i>
                    </button>
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" style='cursor:pointer;' on:click={openCortedia}><i class="bi bi-file-pdf me-1"></i>Corte de Caja</a></li>
                        <li><a class="dropdown-item" style='cursor:pointer;' on:click={openCortediaUnidades}><i class="bi bi-file-pdf me-1"></i>Corte de Unidades</a></li>
                    </ul>                
                </span>
            {/if}
            
            {#if $miPermiso.facturacion.corteperiodo===true}
                <span on:mouseenter={()=>helper='Corte de documentos por periodo'} on:mouseleave={()=>helper=false}>
                    <button disabled={disabled_count} type="button" class="btn btn-info text-white dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
                        <i class="bi bi-printer text-white me-1"></i><i class="bi bi-calendar3 text-white"></i>
                    </button>
                    <!-- svelte-ignore a11y-missing-attribute -->
                    <ul class="dropdown-menu">
                        <li><a class="dropdown-item" style='cursor:pointer;' on:click={corte_periodo}><i class="bi bi-file-pdf me-1"></i>[PDF] CORTE DE DOCUMENTOS POR PERIODO</a></li>
                        <li><a class="dropdown-item" style='cursor:pointer;' on:click={corte_periodo_excel}><i class="bi bi-file-excel me-1"></i>[EXCEL] CORTE DE DOCUMENTOS POR PERIODO</a></li>
                        <div class="dropdown-divider"></div>
                        <li><a class="dropdown-item" style='cursor:pointer;' on:click={acumulado_ventas_dia}><i class="bi bi-file-pdf me-1"></i>[PDF] ACUMULADO DE VENTAS POR DÍA</a></li>
                    </ul>                

                    <!-- <button  class='btn btn-info' on:click={corte_periodo}><i class="bi bi-printer text-white me-1"></i><i class="bi bi-calendar3 text-white"></i></button> -->
                </span>
            {/if}

            <ButtonViewsXpages on:load={()=>{pageActual=0; loadData();}} on:mouseenter={()=>helper='Registros por página'} on:mouseleave={()=>helper=false}/>     

            <BotonOrder uid={uid} on:mouseenter={()=>helper='Ordenar'} on:mouseleave={()=>helper=false} />
        </span>
    </Titlesection>
    <!-- <Searchsection on:change={eventSearch} search={searchText}/> -->

    {#if errores_anulacion===true}
        <div class='mt-2'>
            <Alert parpadea disableMarginBottom valign='top' lheight='2' buttonClose={true} on:close={()=>errores_anulacion=false}>
                <strong>NO SE PUDO ANULAR LA FACTURA:</strong><br/>
                {#each errores_anulacion_mensajes as item}{item}<br/>{/each}
            </Alert>
        </div>
    {/if}

    {#if avanzado===true}
        <div class="container-fluid mt-1" in:fly={{y:-10,duration:500}}>
            <div class="row">
                 
                <!--CAMBIO AGREGAR INPUT -->
                <div class='col-12 mb-2 mt-2'>
                    <Input label='Filtrar por Nombre,NIT, Autorización' bind:value={searchText} on:change={eventText} />
                </div>          

                <div class='col-12 col-md-4 col-lg-4 mb-2'>
                    <Input label='Estado' bind:value={tipo} tipo='select' on:change={eventSearch} datos={[{'0':'Sin Filtrar'},{'A':'ANULADA'},{'E':'EMITIDA'}]} />
                </div>

                {#if filtrohoy===false}
                    <div class='col-12 col-md-8 col-lg-4 mb-2'>
                        <Input label='Fecha' bind:value={desde} bind:value2={hasta} tipo='range' on:change={eventSearch} />
                    </div>
                {:else}
                    <div class='col-12 col-md-8 col-lg-4 mb-2 pt-1 text-success'>
                        <i class="bi bi-calendar-check-fill me-1"></i> Filtro hoy activado
                    </div>
                {/if}
                
                {#if $miPermiso.facturacion.viewSelf===false}
                    <div class='col-12 col-md-4 col-lg-4 mb-2'>
                        <Input label='Usuario' bind:value={usuario} tipo='select' on:change={eventSearch} datos={usuarios} />
                    </div>
                {/if}
                
            </div>
        </div>
    {/if}
    
    <!-- OFFCANVAS CORTE -->
    <div class="offcanvas offcanvas-end" style='width:700px;' bind:this={offcanvas_cortedia} tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
          <h5 id="offcanvasRightLabel">Corte Diario</h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body pt-0">
            <div class="container-fluid border-top border-bottom pt-2 pb-2">
                <div class="row ">
                    <div class='col-12 mb-2'>
                        <Input label='Fecha de Corte' bind:value={fecha_cortedia} tipo='date'/>
                    </div>

                    {#if $miPermiso.facturacion.cortediaselectuser===true}
                        <div class='col-12 mb-2'>
                            <Input label='Usuario' bind:value={usuarioCombo} tipo='select' on:change={eventSearch} datos={usuariosCombo} />
                        </div>
                    {/if}

                    <div class='col-12 mb-2'>
                        <Input height=5 label='Observaciones' bind:value={observaciones_cortedia} tipo='textarea' autofocus={true} bind:this={campo_cortedia}/>
                    </div>
                    <div class='col-12'>
                        <button class='btn btn-success' on:click={cortedia} on:mouseenter={()=>helper='Observaciones'} on:mouseleave={()=>helper=false}><i class="bi bi-save me-1"></i>Hacer Corte</button>
                        <button class='btn btn-danger' on:click={closeCortedia} on:mouseenter={()=>helper='Salir del ingreso'} on:mouseleave={()=>helper=false}><i class="bi bi-arrow-return-left me-1"></i> Salir</button>
                    </div>                        
                </div>
            </div>
        </div>
    </div>

    <!-- OFFCANVAS CORTE UNIDADES -->
    <div class="offcanvas offcanvas-end" style='width:700px;' bind:this={offcanvas_cortediaUNI} tabindex="-1" id="offcanvasRight" aria-labelledby="offcanvasRightLabel">
        <div class="offcanvas-header">
          <h5 id="offcanvasRightLabel">Corte Diario de Unidades</h5>
          <button type="button" class="btn-close text-reset" data-bs-dismiss="offcanvas" aria-label="Close"></button>
        </div>
        <div class="offcanvas-body pt-0">
            <div class="container-fluid border-top border-bottom pt-2 pb-2">
                <div class="row ">
                    <div class='col-12 mb-2'>
                        <Input label='Fecha de Corte' bind:value={fecha_cortediaUNI} tipo='date'/>
                    </div>

                    {#if $miPermiso.facturacion.cortediaselectuser===true}
                        <div class='col-12 mb-2'>
                            <Input label='Usuario' bind:value={usuarioCombo} tipo='select' on:change={eventSearch} datos={usuariosCombo} />
                        </div>
                    {/if}

                    <div class='col-12 mb-2'>
                        <Input height=5 label='Observaciones' bind:value={observaciones_cortediaUNI} tipo='textarea' autofocus={true} bind:this={campo_cortediaUNI}/>
                    </div>
                    <div class='col-12'>
                        <button class='btn btn-success' on:click={cortediaUNI} on:mouseenter={()=>helper='Observaciones'} on:mouseleave={()=>helper=false}><i class="bi bi-save me-1"></i>Hacer Corte</button>
                        <button class='btn btn-danger' on:click={closeCortediaUNI} on:mouseenter={()=>helper='Salir del ingreso'} on:mouseleave={()=>helper=false}><i class="bi bi-arrow-return-left me-1"></i> Salir</button>
                    </div>                        
                </div>
            </div>
        </div>
    </div>

    <!-- DATA GRID -->
    <div class="container-fluid mt-2"> <!--CAMBIO MT-2 -->
        <div class="row">
            <div class="col-12">
                <Datagrid bind:uid={uid} dir={orderDir} order={orderField} on:order={orderTable}>

                    <svelte:fragment slot="header">
                        <DatagridTitle width='100px' order="numdoc" title='#'/>
                        <DatagridTitle order="fechadoc" title='FECHA'/>
                        <DatagridTitle title='NIT'/>
                        <DatagridTitle title='NOMBRE'/>
                        <DatagridTitle title='TOTAL'  align='right'/>
                        <DatagridTitle order="estado" title='ESTADO' align='center'/>
                        <DatagridTitle title='AUTOTIZACIÓN'/>
                        <DatagridTitle title='FECHA PROC'/>
                        <DatagridTitle title='USUARIO'/>

                    </svelte:fragment>
                    <svelte:fragment slot="body">
                    {#each datagrid as item}
                    <DatagridRow id={item.numdoc} bind:seleccionado={seleccionado} on:select={selected}>
                            <DatagridCell title='#'>
                                <ColorStatus status={item.estado}>{item.numdoc}</ColorStatus>
                            </DatagridCell>
                            <DatagridCell title='Fecha'>
                                <ColorStatus status={item.estado}>{moment(item.fechadoc).format('DD/MM/YYYY, HH:mm:ss')}</ColorStatus>
                            </DatagridCell>
                            <DatagridCell title='NIT'>
                                <ColorStatus status={item.estado}>{item.nitcliente}</ColorStatus>
                            </DatagridCell>
                            <DatagridCell title='Nombre'>
                                <ColorStatus status={item.estado}>{item.nomcliente}</ColorStatus>
                            </DatagridCell>
                            <DatagridCell title='Total' align='right'>
                                <ColorStatus status={item.estado}>{moneda(item.total,'Q.')}</ColorStatus>
                            </DatagridCell>
                            <DatagridCell title='Estado' align='center'>
                                {#if item.estado=='E'}
                                    <ColorStatus status={item.estado}>Emitida</ColorStatus>
                                {:else if item.estado=='A'}
                                    <ColorStatus status={item.estado}>Anulada</ColorStatus>
                                {:else if item.estado=='C'}
                                    <ColorStatus status={item.estado}>Cancelada</ColorStatus>
                                {/if}
                            </DatagridCell>
                            <DatagridCell title='Total'>
                                <ColorStatus status={item.estado}>{item.autorizacion}</ColorStatus>
                            </DatagridCell>
                            <DatagridCell title='Fecha Proc'>
                                <ColorStatus status={item.estado}>{moment(item.fechaproc).format('DD/MM/YYYY, HH:mm:ss')}</ColorStatus>
                            </DatagridCell>
                            <DatagridCell title='Usuario'>
                                <ColorStatus status={item.estado}>{item.nomven}</ColorStatus>
                            </DatagridCell>                            
                    </DatagridRow>
                    {/each}
                    
                    </svelte:fragment>
                </Datagrid>

            </div>
        </div>
    </div>

    <!-- PAGINACIÓN -->
    <div class="container mt-3">
        <div class="row">
            <div class="col-12 col-md-6 text-end text-md-start">
            <Infopagination data={dataPagination}/>
            </div>
            <div class="col-12 col-md-6">
            <Pagination selected={pageActual} data={dataPagination} on:page={eventPage}/>
            </div>
        </div>
    </div>
    
    <Helper bind:text={helper}></Helper>
</AnimationContainer>
{/if}